import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { LuArrowUpRight, LuCircleCheck } from 'react-icons/lu';

const quickLinks = [
  { label: 'Home', hash: '#home' },
  { label: 'Gallery', hash: '#gallery' },
  { label: 'About', hash: '#about' },
  { label: 'Testimonials', hash: '#testimonials' },
  { label: 'Order Now', hash: '#order' },
  { label: 'FAQ', hash: '#faq' }
];

const sectionTo = (hash) => ({ pathname: '/', hash });

const services = [
  'Wedding Cakes',
  'Birthday Cakes',
  'Anniversary Cakes',
  'Custom Cakes',
  'Cupcakes',
  'Dessert Tables'
];

const socialLinks = [
  { label: 'Facebook', href: 'https://www.facebook.com/share/17Yv87aXFg/', icon: FaFacebookF },
  { label: 'WhatsApp', href: 'https://wa.me/94778590241', icon: FaWhatsapp }
];

const Footer = () => (
  <footer className="bg-gray-900 text-white py-14 sm:py-16 px-4 sm:px-6 lg:px-8">
    <div className="max-w-7xl mx-auto grid grid-cols-1 gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <h3 className="text-2xl font-bold font-serif mb-4">Nithuja Cakes</h3>
        <p className="text-gray-400 max-w-md leading-relaxed">
          Happiness in Every Slice. Each cake is crafted with passion, precision, and the finest ingredients to
          make your celebrations unforgettable.
        </p>
        <div className="flex flex-wrap gap-3 mt-6">
          {socialLinks.map(({ label, href, icon: Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-gray-300 transition-all duration-200 hover:-translate-y-0.5 hover:border-pink-400/40 hover:bg-pink-500 hover:text-white"
              aria-label={label}
            >
              <Icon className="h-5 w-5" />
            </a>
          ))}
        </div>
      </div>
      <div className="lg:col-span-3">
        <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
        <p className="text-sm text-gray-400 mb-4">Jump straight to the main sections.</p>
        <ul className="flex flex-wrap gap-3">
          {quickLinks.map(({ hash, label }) => (
            <li key={hash} className="w-full sm:w-auto">
              <Link
                to={sectionTo(hash)}
                className="inline-flex w-full sm:w-auto items-center justify-between gap-3 rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-medium text-gray-300 transition-all duration-200 hover:-translate-y-0.5 hover:border-pink-400/40 hover:bg-white/10 hover:text-white"
              >
                <span className="inline-flex items-center gap-2">
                  <LuArrowUpRight className="h-4 w-4 text-pink-400" aria-hidden="true" />
                  {label}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-4">
        <h4 className="text-lg font-semibold mb-4">Cake Services</h4>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {services.map((service) => (
            <li key={service}>
              <span className="inline-flex w-full items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-gray-300">
                <LuCircleCheck className="h-4 w-4 text-green-400" aria-hidden="true" />
                {service}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-gray-800">
      <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div className="text-center md:text-left">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Nithuja Cakes. All rights reserved. |📲 0778590241
          </p>
          <p className="text-gray-400 text-sm mt-1 leading-relaxed">
            Developed by
            <a
              href="https://www.facebook.com/share/17iiR6bmUT/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-white hover:underline ml-1"
            >
              AARA Solutions 
            </a>
             | 📞 0705220729 |
            📧
            <a href="mailto:contact.aarasolutions@gmail.com" className="text-blue-400 hover:underline ml-1">
              contact.aarasolutions@gmail.com
            </a>
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 md:justify-end">
          <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
            Terms of Service
          </Link>
          <Link to="/shipping-policy" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
            Shipping Policy
          </Link>
        </div>
      </div>
      <a
        href="https://wa.me/94778590241"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-emerald-600 text-white p-4 rounded-full shadow-lg z-50 transition-colors duration-200"
        title="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="h-6 w-6 text-white" aria-hidden="true" />
      </a>
    </div>
  </footer>
);

export default Footer;
